export default __webpack_public_path__ + "static/media/SodarDark.8aea6c4c.svg";